import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class Password extends Mixins(CommonView) {
    kurukuru: boolean = false;
    pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"},{name: "パスワード変更", path: null}];

    mode: number = 0;
    error: string = "";
    password: string = "";
    passConfirmation: string = "";

    public async created() {
        this.kurukuru = true;
        if (await this.isLoginRedirect(true)) return;
        this.kurukuru = false;
    }

    public async post() {
        this.kurukuru = true;

        if (!this.passConfirmation || !this.password) {
            this.kurukuru = false;
            this.error = "パスワードを入力してください。";
            return;
        }
        if (this.passConfirmation != this.password) {
            this.kurukuru = false;
            this.error = "パスワードが一致しません。";
            return;
        }

        let profile = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(profile)) {
            this.error = "" + profile.data;
            return;
        }
        let user = profile.data;
        user.password = this.password;
        let res = await BASEAPI.UserController.putUserUsingPUT(user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.mode = 1;
        }
        this.kurukuru = false;
    }
}
